import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isSaveConfigurationButtonVisibleSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('enableSaveConfigurationButton'),
)

export default isSaveConfigurationButtonVisibleSelector
